import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from 'src/app/_services/campaign.service';
import { CreateCampaignModalComponent } from '../create-campaign-modal/create-campaign-modal.component';
import { CampaignStatus, ModalData } from 'src/app/model/campaign';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
  selector: 'app-email-campaign-dashboard',
  templateUrl: './email-campaign-dashboard.component.html',
  styleUrls: ['./email-campaign-dashboard.component.scss']
})
export class EmailCampaignDashboardComponent implements OnInit {
  modalData: ModalData = {campaignName: ''};
  userId: number = this.localStorageService.getItem('userdata').userid;
  successMessage: string;
  errorMessage: string;

  constructor(private router: Router, private emailCampaignService: CampaignService, private modalService: NgbModal, private localStorageService: LocalStorageService) { }

  ngOnInit() {
    this.getCampaigns();
  }

  getCampaigns(data: {}= { created_by: this.userId}) {
    // const tempData = this.campaigns;
    // this.displayCampaigns = tempData.slice(this.startIndex, this.endIndex);
    this.emailCampaignService.getCampaigns(data).subscribe(
      (data: any[]) => {
        if( data['data'] &&  data['data'].length != 0){
          this.router.navigate(['/email-campaign/campaign-listing']); // Navigate to the campaign details page after data is added
          return;
        }
      },
      error => {
        console.error('Error getting campaigns:', error);
      }
    );
  }
  createCampaign(){
    const modalRef = this.modalService.open(CreateCampaignModalComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.modalData = this.modalData;
    modalRef.componentInstance.dataAdded.subscribe((data: ModalData) => {
      // Handle the data added from the modal
      const Campaign ={
        campaign_name: (data.campaignName).trim(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        schedule: "10:00-17:00",
        status: CampaignStatus.Draft
      } 
      // Call the emailCampaignService to create a new campaign based on data
            this.emailCampaignService.createCampaign(Campaign).subscribe(
              (result:any) => {
                if(result.status=='success'){
                  this.router.navigate(['/email-campaign/create-campaign-stages',  result['data'].campaign_id ]) // Navigate to the campaign details page after data is added
                  modalRef.close(); 
                }
                else if(result.status=='failure'){
                  modalRef.close(); 
                  this.errorMessage = result && result.message? result.message : 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
                }
              },
              (error) => {
                this.errorMessage = 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
              }
            );     
    }); 
  }
  // createCampaign(){
  //   this.router.navigate(['/email-campaign/campaign-listing'])
  // }
}
